import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Input, Label } from 'reactstrap'
import { getAllProductType } from "../../../services/api/apiSku"
import { Select } from 'antd'
class FilterSku extends Component {
    state = {
        types: [],
        error: ''
    }

    componentDidMount() {
        this._fetchListSku()
    }

    _fetchListSku = async () => {
        try {
            const { types } = this.state
            const payload = {
               is_deleted: false,
            }

            const { data: response } = await getAllProductType(payload)

            const { success, data, message } = response

            if (!success) {
                return this.setState({
                    error: message
                })
            }

            if (data.length > 0) {
                this.setState({
                    types: data
                })
            }
        } catch (err) {
            this.setState({
                loading: false,
                error: err.message
            })
        }
    }

    _handleChangeSku = (value) => {
        const { onChangeFilters } = this.props

        if (typeof onChangeFilters === 'function') {
            onChangeFilters('sku', value)
        }
    }

    onBlurChangeSelect  = () => {
        const {onChangeFilter, sku} = this.props
        onChangeFilter('sku', sku)
    }

    onDeselectChangeSelect = (value) => {
        const {onChangeFilter, sku} = this.props
    
        onChangeFilter('sku', sku.filter(v => v !== value))
    }

    render() {
        const { sku } = this.props
        const { types } = this.state
        const typeOptions = types.map(type => ({
            label: type.sku,
            value: type.sku
        }))

        return (
            <div className="FilterSku">
                <FormGroup>
                    <Label className='font-weight-bold'>Loại </Label>
                    <Select
                        className='skuFilter'
                        showSearch
                        mode="multiple"
                        style={{ minWidth: '300px' }}
                        placeholder='--- Chọn loại ---'
                        defaultValue={sku}
                        options={typeOptions}
                        optionFilterProp="children"
                        filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                        onChange={this._handleChangeSku}
                        onBlur={this.onBlurChangeSelect}
                        onDeselect={value => this.onDeselectChangeSelect(value)}
                    />
                </FormGroup>
            </div>
        )
    }
}

FilterSku.propTypes = {
    sku: PropTypes.any,
    onChangeFilter: PropTypes.func,
}

export default FilterSku